import styled from 'styled-components';

const StyledShadow = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: radial-gradient(
		50% 50% at 50% 50%,
		rgba(0, 0, 0, 0) 58.17%,
		#000000 100%
	);
	opacity: 0.5;
`;

export { StyledShadow };
